import { registerComponent, defaultStore } from "helpers";

registerComponent(
  "store-location",
  class StoreLocation extends HTMLElement {
    connectedCallback() {
      this.store = JSON.parse(this.dataset.storeLocation);
      this.preferredButton = this.querySelector("[data-preferred-location]");
      this.setStoreButton = this.querySelector("[data-set-location]");

      if (this.setStoreButton) {
        this.updateButtonDisplay();
        this.setStoreButton.addEventListener("click", this.setStore.bind(this));
      }

      if (this.classList.contains("location--my-store")) {
        this.checkDefaultStore();
      }
    }

    checkDefaultStore() {
      const currentStoreId = this.getSelectedStore().shopify_id;
      if (
        !currentStoreId &&
        this.store.shopify_id === defaultStore.shopify_id
      ) {
        this.setDefaultStore(this.store);
      }
      this.toggleStoreDisplay();
    }

    toggleStoreDisplay() {
      const addOrRemove = this.isSelectedStore() ? "remove" : "add";
      this.classList[addOrRemove]("hidden");
    }

    isSelectedStore() {
      const selectedStoreID = this.getSelectedStore().shopify_id;
      return selectedStoreID === this.store.shopify_id;
    }

    updateButtonDisplay() {
      if (this.isSelectedStore()) {
        this.setStoreButton.classList.add("hidden");
        this.preferredButton.classList.remove("hidden");
      }
    }

    setDefaultStore(data) {
      window.localStorage.setItem("storeLocation", JSON.stringify(data));
    }

    setStore() {
      window.localStorage.setItem("storeLocation", JSON.stringify(this.store));
      window.location.reload();
    }

    getSelectedStore() {
      return JSON.parse(window.localStorage.getItem("storeLocation")) || {};
    }
  },
);
